module.exports = __webpack_public_path__ + "9885d50fc85c35a48fc1372649a0c18e.png";